import React, { useContext } from "react";
import { ProviderDynamicDiscount } from "app/setup/modules/provider/features";
import { OperatorDynamicDiscount } from "app/setup/modules/operator/features";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";

import constant from "lib/constant/constant";

const { userKey } = constant;
const { provider, operator } = userKey;

const DynamicDiscount = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === provider) {
      return <ProviderDynamicDiscount />;
    }
    if (role === operator) {
      return <OperatorDynamicDiscount />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const DiscountComponent = getComponent(currentUserRole);
  return DiscountComponent;
};

export default DynamicDiscount;
